import { render, staticRenderFns } from "./DocumentsTreeNode.vue?vue&type=template&id=49fe937a&scoped=true&lang=pug"
import script from "./DocumentsTreeNode.vue?vue&type=script&lang=ts"
export * from "./DocumentsTreeNode.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsTreeNode.vue?vue&type=style&index=0&id=49fe937a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fe937a",
  null
  
)

export default component.exports